import { useState } from 'react';
import { testimonials } from '@/mocks/articles';

export default function TestimonialSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonial = testimonials[currentIndex];

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            （网友精选爆料）
          </h2>
        </div>

        <div className="relative bg-background-50 rounded-xl md:rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-foreground-900 text-accent-400 text-xs font-label font-semibold rounded-full">
              <i className="ri-star-fill text-sm"></i>
              {testimonial.rating}
            </span>
          </div>

          <blockquote className="mb-8">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-label italic">
              "{testimonial.comment}"
            </p>
          </blockquote>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div>
                <p className="text-sm font-label font-semibold text-foreground-900">
                  {testimonial.name}
                </p>
                <p className="text-xs text-foreground-400">
                  {testimonial.date}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={goPrev}
                className="w-10 h-10 flex items-center justify-center border border-background-300 rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                aria-label="上一条"
              >
                <i className="ri-arrow-left-s-line text-foreground-700"></i>
              </button>
              <button
                onClick={goNext}
                className="w-10 h-10 flex items-center justify-center bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                aria-label="下一条"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  idx === currentIndex ? 'bg-primary-500 w-6' : 'bg-background-300'
                }`}
                aria-label={`第${idx + 1}条`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}